import { Modal, Typography } from "antd";
import React, { useState } from "react";

const { Title } = Typography;

const Terms: React.FC = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {/* A real button, so the terms can be opened with the keyboard. preventDefault stops the click from also
          toggling the checkbox this sits inside. */}
      <button
        type="button"
        onClick={e => {
          e.preventDefault();
          setVisible(true);
        }}
        style={{
          textDecoration: "underline",
          padding: 0,
          border: "none",
          background: "none",
          color: "inherit",
          font: "inherit",
          cursor: "pointer",
        }}
      >
        vilkårene for booking
      </button>
      <Modal
        title={<Title level={5}>Vilkår for booking av bedriftspresentasjon</Title>}
        centered
        open={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        footer={null}
        bodyStyle={{ width: "auto", maxHeight: "calc(100vh - 200px)" }}
      >
        <ul>
          <li>
            Ved booking av bedriftspresentasjon gjelder en angrerett på 14 dager uten kostnad*, deretter påløper et
            avbestillingsgebyr på 100% av den avtalte prisen.
            <br />
            <br />{" "}
          </li>
          <li>
            *Dersom det er mindre enn 14 dager til bedriftspresentasjonen skal foregå, bortfaller retten til kostnadsfri
            avbestilling, og det vil kun være 24-timers angrerett. Det vil si at avbestilling vil medføre et gebyr på
            100%, uavhengig av når bookingen ble gjort.
            <br />
            <br />{" "}
          </li>
          <li>Minst halvparten av plassene på arrangementet må være satt av til Indøk-studenter.</li>
        </ul>
      </Modal>
    </>
  );
};

export default Terms;
